import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { CustomdataResponse, QueryRequest, Response } from '@models/index.model';
import { SpConfigResponse } from '@models/personal/personal.model';

@Injectable()
export class PersonalService {
  private UrlAPI = environment.apiUrl;

  constructor(
    private http: HttpClient,
  ) { }

  public getCustomData(): Observable<Response<CustomdataResponse>> {
    const query = this.UrlAPI + QueryRequest.customdata;
    return this.http.get<Response<CustomdataResponse>>(query);
  }

  public getSPConfig(): Observable<Response<SpConfigResponse>> {
    const query = this.UrlAPI + QueryRequest.spConfig;
    return this.http.get<Response<SpConfigResponse>>(query);
  }

  public personalSSODomain(): Observable<Response<string>> {
    const query = this.UrlAPI + QueryRequest.personalSSODomain;
    return this.http.get<Response<string>>(query);
  }
}
